














































import { computed } from "@vue/composition-api";
import Vue from "vue";
import { state } from "../data/state";
export default Vue.extend({
  setup() {
    const { subjects, change_subject, current_subject, remove_subject } = state;
    const has_more_than_one_subject = computed(
      () => Object.values(subjects.value).length > 1
    );
    return {
      subjects,
      has_more_than_one_subject,
      change_subject,
      current_subject,
      remove_subject,
    };
  },
});
